import React, {
  FC, useCallback, useEffect, useState,
} from 'react';

import { AffectedQuestions } from '../../commons/AffectedQuestions';
import { QBackButton } from '../../commons/QBackButton';
import { QConfirmButton } from '../../commons/QConfirmButton';
import { QHeader } from '../../commons/QHeader';

import { Q44Form } from './form';
import { Q44Response } from './form/types';
import { Row } from 'components/base/Row';
import { BudgetQuestionCodes } from 'modules/budget/data/budgetQuestionCodes';
import { useBudget } from 'modules/budget/hooks/useBudget';
import { Article } from 'modules/budget/models/Article';

export const Q44: FC<Record<string, unknown>> = () => {
  const question = BudgetQuestionCodes.Q44;
  const { RespondQuestion } = useBudget();

  const [canConfirm, setCanConfirm] = useState<boolean>(false);
  const [selectedArticles, setSelectedArticles] = useState<Article[]>([]);
  const [dismissService, setDismissService] = useState<boolean>(false);
  const [autorespond, setautorespond] = useState<boolean>(false);

  useEffect(
    () => {
      setCanConfirm(dismissService || selectedArticles.length > 0);
    },
    [dismissService, selectedArticles.length],
  );

  const response = useCallback(
    ({ gotoSummary }) => {
      RespondQuestion({
        gotoSummary,
        question,
        response: {
          articles: selectedArticles,
        },
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedArticles],
  );

  const onChange = useCallback(
    (responseData: Q44Response) => {
      setDismissService(responseData.dismissService);
      setSelectedArticles(responseData.articles);
      setautorespond(responseData.autorespond);
    },
    [],
  );

  useEffect(
    () => {
      if (autorespond && canConfirm) {
        setautorespond(false);
        response({ gotoSummary: false });
      }
    },
    [autorespond, canConfirm, response],
  );

  return (
    <React.Fragment>
      <QHeader question={question} />
      <Q44Form
        question={question}
        onChange={onChange}
      />
      <Row justifyContent="space-between">
        <QBackButton question={question} />
        <Row
          className="f-question-actions"
          justifyContent="flex-end"
        >
          <AffectedQuestions
            question={question}
            response={{
              articles: selectedArticles,
            }}
          />
          <QConfirmButton
            disabled={!canConfirm}
            question={question}
            onClick={(payload) => response({ gotoSummary: payload?.gotoSummary })}
          />
        </Row>
      </Row>
    </React.Fragment>
  );
};
